"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhranní pro přístup k pracovníkům. Generated from cz.marbes.api.organizace.v1.PracovnikService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:27Z                      #

// ##############################################################

var PracovnikApi = function () {
  function PracovnikApi() {
    (0, _classCallCheck3.default)(this, PracovnikApi);
  }

  (0, _createClass3.default)(PracovnikApi, null, [{
    key: "findPracovnici",

    /**
     * Fulltextové hledání pracovníků.
     *
     * @param fulltext fulltext řetězec
     * @param proSpustenouAplikaci pokud je true, hledá jen mezi pracovníky aktuýálně spuštěné aplikace, jinak hledá mezi všemi pracovníky
     * @param max maximální počet vrácených záznamů, max. však {@link #FULLTEXT_MAX}
     * @return nalezení pracovníci nebo prázdný seznam
     */
    value: function findPracovnici(fulltext, proSpustenouAplikaci, max) {
      var uri = serverContextPath + "/api/organizace/v1";
      var headers = undefined;
      var params = { fulltext: fulltext, proSpustenouAplikaci: proSpustenouAplikaci, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí pracovníka s daným ID
     *
     * @param id ID pracovníka
     * @return pracovník
     */

  }, {
    key: "getPracovnikById",
    value: function getPracovnikById(id) {
      var uri = serverContextPath + ("/api/organizace/v1/pracovnici/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde pracovníky s předanými ID.
     *
     * @param ids množina ID pracovníků
     * @return nalezení pracovníci
     */

  }, {
    key: "findPracovniciByIds",
    value: function findPracovniciByIds(ids) {
      var uri = serverContextPath + "/api/organizace/v1/pracovnici/byIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, ids, headers));
    }
  }]);
  return PracovnikApi;
}();

exports.default = PracovnikApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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